import React from 'react';
import { Icon } from './Icon.js';
export const IconChartArea2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M2.25 10.4995C1.00737 10.4994 0 9.49209 0 8.24945V5.55316C4.19617e-05 4.97077 0.290256 4.42616 0.773438 4.10102L2.81738 2.72602C3.22017 2.45505 3.7432 2.44164 4.15918 2.69184L6.26562 3.95941L10.1123 1.67816C10.9456 1.18412 12 1.78466 12 2.75336V8.24945C12 9.49209 10.9926 10.4995 9.75 10.4995H2.25Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconChartArea2Fill12.js.map